import type { ShallowTeacherResource } from "api/generated";
import type { ShallowTeacher } from "shared/types";

export const mapShallowTeacher = (
  resource: ShallowTeacherResource,
): ShallowTeacher => ({
  id: resource.id,
  firstName: resource.first_name,
  middleName: resource.middle_name ?? null,
  lastName: resource.last_name,
  shortage: resource.shortage ?? null,
  fullName: resource.full_name,
  profileImage: resource.profile_image || null,
  role: resource.role,
});
